/**
 * Generated pages run in a sandbox without `allow-same-origin` (see
 * `GENERATED_HTML_SANDBOX`), which gives them an opaque origin. On an opaque origin
 * `window.localStorage` throws a `SecurityError` on *access* rather than returning
 * null, so a top-level `localStorage.getItem(...)` kills the whole script and the page
 * renders blank.
 *
 * This installs in-memory stand-ins so those pages run and simply do not persist across
 * reloads. It is a no-op wherever the real storage works, and is injected into the chat
 * preview and both published viewers alike so behaviour matches everywhere.
 *
 * Not covered — these still throw on an opaque origin: `document.cookie`, `indexedDB`,
 * `caches`, `navigator.serviceWorker`, and `history.pushState()` with a URL argument.
 */
export function sandboxedStorageShimScriptSource(): string {
  return `(function(){
function createStorage(){
var data=Object.create(null)
var api={
getItem:function(key){var k=String(key);return k in data?data[k]:null},
setItem:function(key,value){data[String(key)]=String(value)},
removeItem:function(key){delete data[String(key)]},
clear:function(){data=Object.create(null)},
key:function(index){var keys=Object.keys(data);var i=Number(index);return i>=0&&i<keys.length?keys[i]:null}
}
var own=function(target,prop){return Object.prototype.hasOwnProperty.call(target,prop)}
return new Proxy(api,{
get:function(target,prop){
if(prop==='length')return Object.keys(data).length
if(own(target,prop))return target[prop]
if(typeof prop==='string'&&prop in data)return data[prop]
return target[prop]
},
set:function(target,prop,value){
if(prop==='length'||own(target,prop))return true
data[String(prop)]=String(value)
return true
},
has:function(target,prop){
return prop==='length'||own(target,prop)||(typeof prop==='string'&&prop in data)
},
deleteProperty:function(target,prop){delete data[String(prop)];return true},
ownKeys:function(){return Object.keys(data)},
getOwnPropertyDescriptor:function(target,prop){
if(typeof prop==='string'&&prop in data)return {value:data[prop],writable:true,enumerable:true,configurable:true}
return Object.getOwnPropertyDescriptor(target,prop)
}
})
}
function install(name){
try{
var native=window[name]
if(native){native.getItem('__evergpt_probe__');return}
}catch(error){/* opaque origin: real storage is unreachable, fall through */}
try{
Object.defineProperty(window,name,{value:createStorage(),configurable:true})
}catch(error){/* non-configurable somehow: nothing further we can do */}
}
install('localStorage')
install('sessionStorage')
})()`
}

/** Serialized `<script>` for string-based head injection (split closing tag for HTML parsers). */
export function sandboxedStorageShimScriptHtml(): string {
  return '<script>' + sandboxedStorageShimScriptSource() + '</scr' + 'ipt>'
}
